import { render, staticRenderFns } from "./bizCardModfiyPage.vue?vue&type=template&id=8ea7415e&scoped=true&"
import script from "./bizCardModfiyPage.vue?vue&type=script&lang=js&"
export * from "./bizCardModfiyPage.vue?vue&type=script&lang=js&"
import style0 from "./bizCardModfiyPage.vue?vue&type=style&index=0&id=8ea7415e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea7415e",
  null
  
)

export default component.exports